import { makeAutoObservable, runInAction } from "mobx";
import OnboardingService from "../../services/api/onboarding-service";
import { rootContainer, TYPE } from "../../services/container/root";
import { toBoolean } from "../../models/model-types-methods";

export interface IReturnGuardWarning {
    is_shown: boolean;
    button_action_url: string;
    component_variant: RETURN_GUARD_WARNING_TYPE;
    translation_scope: string;
    warning_translation_key: string;
    button_translation_key: string;
    translation_args: [];
}

export enum RETURN_GUARD_WARNING_TYPE {
	WARNING = 'warning',
	ERROR = 'error',
}

class ReturnGuardWarningStore {
    private _isLoading: boolean = false;
    private _model?: IReturnGuardWarning;
    private _height: number = 0;

    constructor() {
        makeAutoObservable(this, {},{autoBind: true}); 
    }

    public get isLoading(): boolean { return this._isLoading; }
    public get isShown(): boolean { return this._model?.is_shown ?? false; }
    public get buttonActionUrl(): string { return this._model?.button_action_url ?? '#'; }
    public get componentVariant(): RETURN_GUARD_WARNING_TYPE|undefined { return this._model?.component_variant; }
    public get translationScope(): string { return this._model?.translation_scope ?? ''; }
    public get warningTranslationKey(): string { return this._model?.warning_translation_key ?? ''; }
    public get buttonTranslationKey(): string { return this._model?.button_translation_key ?? ''; }
    public get translationArgs(): [] { return this._model?.translation_args ?? []; }
    public get height(): number { return this._height; }

    public setHeight(height: number) {
        this._height = height;
    }

    private get onboardingService(): OnboardingService {
        return rootContainer.get<OnboardingService>(TYPE.OnboardingService);
    }

    public async load() {
        this._isLoading = true;
        try {
            const res = await this.onboardingService.getReturnGuardWarning();
            runInAction(() => {
                this._model = ensureValidModel(res);
                this._isLoading = false;
            });
        } catch (e) {
            runInAction(() => {
                this._isLoading = false;
            });
        }
    }
}

const returnGuardWarningStore = new ReturnGuardWarningStore();
export default returnGuardWarningStore;

function ensureValidModel(model: IReturnGuardWarning) {
    return {...model,
        is_shown: toBoolean(model.is_shown),
    }
}